<template>
  <div id="contenedor-eliminar-proyecto-documento-tipo">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar tipo de documento </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar el tipo de documento {{ proyectoDocumentoTipoEliminar.descripcion }}?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarProyectoDocumentoTipo"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixProyectoDocumentosTipos from './mixProyectoDocumentosTipos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarProyectoDocumentoTipo',
  mixins: [mixProyectoDocumentosTipos],
  props: {
    proyectoDocumentoTipoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
